import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { LoginButton } from './LoginButton';

/**
 * AuthGuard component - protects routes that require authentication
 */
export function AuthGuard({ children }) {
  const { authenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (!authenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center space-y-4">
          <h1 className="text-2xl font-semibold text-foreground">Authentication Required</h1>
          <p className="text-muted-foreground">
            Please sign in with Onshape to access this page.
          </p>
          <LoginButton />
        </div>
      </div>
    );
  }

  return children;
}

